// extracted by mini-css-extract-plugin
module.exports =  {"preview":"preview--qzyXc","cover-mode":"cover-mode--AFtMd","coverMode":"cover-mode--AFtMd","iframe":"iframe--qsW9m"};